import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import StorageContainerWrapper from "@components/layouts/storagecontainerpricesWrapper";

export default function StorageContainerPricesHome(): ReactElement {
    return (
        <StorageContainerWrapper>
            <PrivacyPolicy
                domain="storagecontainerprices.com"
                category="Storage Containers"
            />
        </StorageContainerWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
